import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const SettingIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.486 3.957C11.118 2.723 12.881 2.723 13.513 3.957L14.329 5.551C14.68 6.238 15.396 6.661 16.167 6.639L17.949 6.588C19.28 6.549 20.137 7.988 19.468 9.14L18.391 10.997C18.031 11.617 18.031 12.383 18.391 13.004L19.468 14.86C20.137 16.012 19.28 17.451 17.949 17.413L16.167 17.362C15.396 17.339 14.68 17.763 14.329 18.449L13.513 20.044C12.881 21.278 11.118 21.278 10.486 20.044L9.67 18.449C9.319 17.763 8.604 17.339 7.833 17.362L6.05 17.413C4.719 17.451 3.863 16.012 4.531 14.86L5.608 13.004C5.968 12.383 5.968 11.617 5.608 10.997L4.531 9.14C3.863 7.988 4.719 6.549 6.05 6.588L7.833 6.639C8.604 6.661 9.319 6.238 9.67 5.551L10.486 3.957Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M14.5 12C14.5 13.381 13.38 14.5 12 14.5C10.619 14.5 9.5 13.381 9.5 12C9.5 10.619 10.619 9.5 12 9.5C13.38 9.5 14.5 10.619 14.5 12Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

SettingIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(SettingIcon);
